import { LegacyPopover } from '@creditornot/cb-popover';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { Typography } from 'common/typography';

export type ListItemNameProps = {
  children: string;
};

const Text = styled(Typography.Body2)`
  display: block;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const MenuItemName = ({ children }: ListItemNameProps) => {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    setIsOverflowing((ref.current?.scrollWidth || 0) > (ref.current?.offsetWidth || 0));
  }, []);

  return (
    <LegacyPopover content={children} placement="top-start" disabled={!isOverflowing}>
      <Text ref={ref}>{children}</Text>
    </LegacyPopover>
  );
};
